import {
  ControlFilter,
  ConversationFilterIds,
  ConversationStatusFilter,
  ScreeningStatusFilter
} from '../constants/enums';
import { ApplicationStage } from '../types';
import { ApplicationStageMapper } from './applicationStageMapper';
import { meetingOptions } from '../constants/meetingOptions';

export const getConversationFilterLabel = (
  filterId: ConversationFilterIds,
  value: string | boolean
) => {
  if (filterId === ConversationFilterIds.applicationStage) {
    return ApplicationStageMapper[value as ApplicationStage];
  }

  if (filterId === ConversationFilterIds.meetingBookingStatus) {
    return (
      meetingOptions.find((option) => option.value === value)?.label ??
      String(value)
    );
  }

  if (filterId === ConversationFilterIds.control) {
    switch (value) {
      case ControlFilter.MANUAL:
        return 'You';
      case ControlFilter.AI:
        return 'Popp';
    }
  }

  if (filterId === ConversationFilterIds.status) {
    switch (value) {
      case ConversationStatusFilter.REVIEW:
        return 'Review';
      case ConversationStatusFilter.MORE_TIME_REQUESTED:
        return 'More time requested';
      case ConversationStatusFilter.CREATED:
        return 'Created';
      case ConversationStatusFilter.ONGOING:
        return 'In progress';
      case ConversationStatusFilter.OPTED_OUT:
        return 'Opted out';
      case ConversationStatusFilter.QUEUED:
        return 'Queued';
      case ConversationStatusFilter.CLOSED:
        return 'Closed';
      case ConversationStatusFilter.NOT_DELIVERED:
        return 'Not delivered';
    }
  }

  if (filterId === ConversationFilterIds.screeningStatus) {
    switch (value) {
      case ScreeningStatusFilter.PROGRESSED:
        return 'Satisfied';
      case ScreeningStatusFilter.REJECTED:
        return 'Not satisfied';
      case ScreeningStatusFilter.NOT_INTERESTED:
        return 'Not interested';
      case ScreeningStatusFilter.INCOMPLETE:
        return 'Incomplete';
      case ScreeningStatusFilter.OPTED_OUT:
        return 'Opted out';
    }
  }

  return String(value);
};
